/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tool
 */
export interface Tool {
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    partNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof Tool
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Tool
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Tool
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Tool interface.
 */
export function instanceOfTool(value: object): value is Tool {
    return true;
}

export function ToolFromJSON(json: any): Tool {
    return ToolFromJSONTyped(json, false);
}

export function ToolFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tool {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function ToolToJSON(value?: Tool | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

